/**
 * Component Registry for Repli Sandbox Theme
 * 
 * Extends the base preferred theme registry with Repli Sandbox specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-preferred/registry';

/**
 * Repli Sandbox specific component overrides.
 * These components have been customized for the Repli Sandbox brand.
 * 
 * Example:
 * import { Footer } from './components/Footer';
 * 
 * const replisandboxOverrides: Partial<ComponentRegistry> = {
 *   Footer,
 * };
 */
const replisandboxOverrides: Partial<ComponentRegistry> = {
  // Add component overrides here
};

/**
 * Final merged registry for Repli Sandbox properties.
 * Inherits all components from the preferred theme, with Repli Sandbox overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...replisandboxOverrides,
};

export default registry;
